import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { IFeaturesContext } from 'SharedComponents/hooks/useFeatures';

interface UserIdCellRendererProps {
    features: IFeaturesContext;
    // TODO Update transaction record to match with the actual SenderUserName
    data: any;
}

const muiStyles = makeStyles({
    userId: {
        fontSize: '.9rem',
        lineHeight: '1.2rem'
    },
    SSORequesterId: {
        fontSize: '.75rem',
        lineHeight: '.9rem',
        color: '#E68856'
    }
});

const UserIdCellRenderer = (props: UserIdCellRendererProps) => {
    const {
        features,
        data
    } = props;
    const classes = muiStyles(props);

    return (
        <Grid
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span className={classes.userId}>{data.SenderUsername}</span>
            {features.isSSOEnabled && <span className={classes.SSORequesterId}>{data.SSORequesterId}</span>}
        </Grid>
    );
};

export default UserIdCellRenderer;